import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import opensea from "../assets/opensea.png";

const Footer = () => {
  return (
    <footer className="text-center">
      <ul class="hstack justify-content-center footer-social">
        <li>
          <a
            class="nav-link"
            href="https://opensea.io/collection/gutter-bats-planet-"
            rel="noreferrer"
            target="_blank"
          >
            <img
              src={opensea}
              style={{ width: 20, marginTop: -5, cursor: "pointer" }}
            />
          </a>
        </li>
        <div
          style={{
            borderLeft: "2px solid var(--light)",
            height: "20px",
            margin: "0px 5px",
          }}
        />
        <li>
          <a
            class="nav-link"
            href="https://discord.gg/Fdsu6PPW"
            rel="noreferrer"
            target="_blank"
          >
            <i class="bi bi-discord"></i>
          </a>
        </li>
        <div
          style={{
            borderLeft: "2px solid var(--light)",
            height: "20px",
            margin: "0px 5px",
          }}
        />
        <li>
          <a
            class="nav-link"
            href="https://twitter.com/GBPnftPro"
            rel="noreferrer"
            target="_blank"
          >
            <i class="bi bi-twitter"></i>
          </a>
        </li>
        <div
          style={{
            borderLeft: "2px solid var(--light)",
            height: "20px",
            margin: "0px 5px",
          }}
        />
        <li>
          <a
            class="nav-link"
            href="https://www.instagram.com/gutter_bats_planet/"
            rel="noreferrer"
            target="_blank"
          >
            <i class="bi bi-instagram"></i>
          </a>
        </li>
        <div
          style={{
            borderLeft: "2px solid var(--light)",
            height: "20px",
            margin: "0px 5px",
          }}
        />
        <li>
          <a class="nav-link" href="" rel="noreferrer" target="_blank">
            <i class="bi bi-linkedin"></i>
          </a>
        </li>
      </ul>
      <div className="hstack justify-content-center">
        <img src={logo} width="50" style={{ margin: "0px 5px" }} />
        <span>&copy; 2022 Gutter Bats Planet.</span>
        <span
          style={{
            borderLeft: "2px solid var(--light)",
            height: "20px",
            margin: "0px 10px",
          }}
        />
        <ul
          style={{
            display: "flex",
            listStyle: "none",
            padding: 0,
            margin: 0,
          }}
        >
          <li style={{ color: "var(--secondary)", cursor: "pointer" }}>
            <Link to="/terms" style={{ all: "unset" }}>
              Terms of Sale
            </Link>
          </li>
          <span
            style={{
              borderLeft: "2px solid var(--light)",
              height: "20px",
              margin: "0px 10px",
            }}
          />
          <li
            style={{
              color: "var(--secondary)",
              cursor: "pointer",
            }}
          >
            <a href="mailto:contact@gutterbats.com" style={{ all: "unset" }}>
              contact@gutterbats.com
            </a>
          </li>
          <span
            style={{
              borderLeft: "2px solid var(--light)",
              height: "20px",
              margin: "0px 10px",
            }}
          />
          <li style={{ color: "var(--secondary)", cursor: "pointer" }}>
            <a href="mailto:mint@gutterbats.com" style={{ all: "unset" }}>
              mint@gutterbats.com
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
